import React from 'react';
import { Modal, Button, Result ,Typography } from 'antd';
const { Text } = Typography; 
const PaymentResultModal = ({ isVisible, paymentStatus, onClose }) => {
    return (
        <Modal
            visible={isVisible}
            footer={[
                <Button type="primary" key="dismiss" onClick={onClose}>
                    Dismiss
                </Button>,
            ]}
            onCancel={onClose}
        >
            <Result
                status={paymentStatus === 'success' ? 'success' : 'error'}
                title={paymentStatus === 'success' ? 'Payment Successful' : 'Payment Unsuccessful'}
                extra={<Text type='secondary'>Your payment has been Successful, you can now view your invoice and events.</Text>}
            />
        </Modal>
    );
};

export default PaymentResultModal;  
